import { useEffect, useState } from 'react';
import { zeitTextAusSekunden } from '../lib/format';

/** Rechnet aus der serverseitigen Endzeit, statt bei jedem Socket-Update neu zu starten. */
export function PollCountdown({ closesAt }: { closesAt: string }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const tick = () => setNow(Date.now());
    tick();
    const timer = setInterval(tick, 250);
    return () => clearInterval(timer);
  }, [closesAt]);
  const left = Math.max(0, Math.ceil((Date.parse(closesAt) - now) / 1000));
  return <span className="poll-zeit">{zeitTextAusSekunden(left)}</span>;
}
